<template>
  <div class="container">
    <table></table>
    <div class="main" v-if="obj">
      <img src="static/img/icon3.png" class="avatar" v-if="!obj.img" alt="" />
      <img :src="obj.img" class="avatar" v-else alt="" />
      <div class="list">
        <p class="title">姓名</p>
        <p class="desc">{{ obj.name }}</p>
      </div>
      <div class="list">
        <p class="title">证件类型</p>
        <p class="desc">{{ obj.cert_type }}</p>
      </div>
      <div class="list">
        <p class="title">证件编号</p>
        <p class="desc">{{ obj.cert }}</p>
      </div>
      <div class="list">
        <p class="title">志愿者编号</p>
        <p class="desc">{{ obj.member_no }}</p>
      </div>
      <div class="list">
        <p class="title">政治面貌</p>
        <p class="desc">{{ obj.politics_face }}</p>
      </div>
      <div class="list">
        <p class="title">性别</p>
        <p class="desc">{{ obj.gender }}</p>
      </div>
      <div class="list">
        <p class="title">手机号</p>
        <p class="desc">{{ obj.mobile }}</p>
      </div>
      <div class="list">
        <p class="title">区县</p>
        <p class="desc">{{ obj.street }}-{{ obj.village }}</p>
      </div>
      <div class="list">
        <p class="title">擅长技能</p>
        <p class="desc">{{ obj.skillstr }}</p>
      </div>
      <div class="list">
        <p class="title">出生年月</p>
        <p class="desc">{{ obj.birthday }}</p>
      </div>
      <div class="list">
        <p class="title">籍贯</p>
        <p class="desc">{{ obj.native_place }}</p>
      </div>
      <div class="list">
        <p class="title">国籍</p>
        <p class="desc">{{ obj.guojia }}</p>
      </div>
      <div class="list">
        <p class="title">文化程度</p>
        <p class="desc" v-if="obj.wenhua == 1">初中</p>
        <p class="desc" v-else-if="obj.wenhua == 2">高中</p>
        <p class="desc" v-else-if="obj.wenhua == 3">中技</p>
        <p class="desc" v-else-if="obj.wenhua == 4">中专</p>
        <p class="desc" v-else-if="obj.wenhua == 5">大专</p>
        <p class="desc" v-else-if="obj.wenhua == 6">本科</p>
        <p class="desc" v-else-if="obj.wenhua == 7">硕士</p>
        <p class="desc" v-else-if="obj.wenhua == 8">博士</p>
      </div>
      <div class="list">
        <p class="title">民族</p>
        <p class="desc">{{ obj.minzu }}</p>
      </div>
      <div class="list">
        <p class="title">毕业院校</p>
        <p class="desc">{{ obj.school }}</p>
      </div>
      <div class="list">
        <p class="title">所学专业</p>
        <p class="desc">{{ obj.major }}</p>
      </div>
      <div class="list">
        <p class="title">工作单位</p>
        <p class="desc">{{ obj.compony }}</p>
      </div>
      <div class="list">
        <p class="title">职称</p>
        <p class="desc">{{ obj.zhicheng }}</p>
      </div>
    </div>
    <!-- 底部 -->
    <div class="bottom">
      <div
        class="bt"
        style="color: #1646c0; background: white; border: 1px solid #1646c0"
        @click="shenhe(2)"
      >
        审核拒绝
      </div>
      <div
        class="bt"
        style="color: white; background: #1646c0; border: 1px solid #1646c0"
        @click="shenhe(1)"
      >
        审核通过
      </div>
    </div>
    <table></table>
  </div>
</template>
<script>
import { Dialog } from "vant";
export default {
  name: "checkdetail",
  data() {
    return {
      obj: null,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.$axios
        .post(
          "/api/org/member_info",
          this.qs.stringify({
            id: this.$route.query.id,
          })
        )
        .then((res) => {
          //console.log(res);
          if (res.data.code != 0) {
            this.$toast(res.data.msg);
          } else {
            this.obj = res.data.data;
            if (this.obj.skill) {
              let list = this.obj.skill.split(",");
              for (let i in list) {
                switch (list[i]) {
                  case "1":
                    list[i] = "外语";
                    break;
                  case "2":
                    list[i] = "书法";
                    break;
                  case "3":
                    list[i] = "绘画";
                    break;
                  case "4":
                    list[i] = "电脑维修";
                    break;
                  case "5":
                    list[i] = "文化辅导";
                    break;
                  case "6":
                    list[i] = "编辑写作";
                    break;
                  case "7":
                    list[i] = "话剧";
                    break;
                  case "8":
                    list[i] = "演讲";
                    break;
                  case "9":
                    list[i] = "节目主持";
                    break;
                  case "10":
                    list[i] = "电脑编程";
                    break;
                  case "11":
                    list[i] = "摄影";
                    break;
                  case "12":
                    list[i] = "漫画";
                    break;
                  case "13":
                    list[i] = "唱歌";
                    break;
                  case "14":
                    list[i] = "推拿按摩";
                    break;
                  case "15":
                    list[i] = "创意策划";
                    break;
                  case "16":
                    list[i] = "处理应变";
                    break;
                  case "17":
                    list[i] = "社交外联";
                    break;
                  case "18":
                    list[i] = "人事管理";
                    break;
                  case "19":
                    list[i] = "平面设计";
                    break;
                  default:
                    break;
                }
              }
              this.obj.skillstr = list.join(",");
            }
          }
        });
    },
    shenhe(status) {
      Dialog.confirm({
        title: "提示",
        message: "确定进行该操作吗",
      })
        .then(() => {
          // on confirm
          this.$axios
            .post(
              "/api/org/pass_member",
              this.qs.stringify({
                org_id: this.$route.query.org_id || "",
                id: this.$route.query.id || "",
                ispass: status,
              })
            )
            .then((res) => {
              console.log(res);
              if (res.data.code == 0) {
                this.$router.go(-1);
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>
<style scoped>
.container {
  min-height: 100vh;
  background: #f5f6f7;
}
.main {
  padding: 24px 16px;
  border-radius: 8px;
  margin: 10px;
  background: white;
  margin-bottom: 100px;
}
.avatar {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 14px;
}
.list {
  display: flex;
  font-size: 14px;
  line-height: 22px;
  padding: 10px 0;
}
.title {
  color: #999;
  width: 7em;
  white-space: nowrap;
}
.desc {
  color: #333;
}
.bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 88px;
  background: white;
  box-shadow: 0px -2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
}
.bottom .bt {
  width: 40%;
  margin: auto;
  margin-top: 16px;
  height: 48px;
  line-height: 48px;
  font-size: 16px;
  border-radius: 4px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/checkdetail.vue